import styled from 'styled-components/macro';

const Header = styled.h2`
  #certiself-form & {
    color: #552a55;
    font-size: 35px;
    margin-bottom: 17px;
  }
`;

const Paragraph = styled.p`
  #certiself-form & {
    margin-bottom: 17px;
  }
`;

const Section = styled.section`
  #certiself-form & {
    margin-bottom: 35px;
  }
`;

const Form = styled.form`
  #certiself-form & {
    display: flex;
    flex-direction: column;
    font-size: 17px;
  }
`;

export { Header, Paragraph, Section, Form };
